import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NgForm } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { CompanyInterface } from '../company';
import { CustomerDataService } from '../services/customer-data.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class SettingComponent implements OnInit {
  @ViewChild('userForm') userForm!: NgForm;
  users: any = [];
  public isVisible = false;
  public editVisible = false;
  public submit = false;
  public frmRegister!: UntypedFormGroup;
  public userDetails: any;

  public Created_at: any = new Date().toISOString();
  public Name: any;
  public Email: any;
  public Password: any = 'nani12345'
  public Role: any;
  public Status: any = 'active';
  public id: any
  public message: any
  constructor(private activateroute: ActivatedRoute, private route: Router,
    private data: CustomerDataService, private fb: UntypedFormBuilder) {

  }

  public styleObject = {
    top: '160px',
    right: '10px',
    width: '500px',
    height: '100px',
  };
  showModal(): void {
    this.isVisible = true;

  }

  handleCancel(): void {
    this.isVisible = false;
    this.editVisible = false
  }


  ngOnInit(): void {

    this.data.getAllDetails().subscribe((data: any) => {
      this.userDetails = data.map((value: any) => {
        // console.log(value.payload.doc.data().created_at)
        return {
          id: value.payload.doc.id,
          isedit: false,
          created: value.payload.doc.data().created_at,
          name: value.payload.doc.data().name,
          email: value.payload.doc.data().uid,
          role: value.payload.doc.data().role,
          status: value.payload.doc.data().status,
        };
      });
      console.log(this.userDetails)
    });

    this.frmRegister = new UntypedFormGroup({
      name: new UntypedFormControl(''),
      email: new UntypedFormControl(''),
      role: new UntypedFormControl(''),

    });

  }

  createRecord(): any {
    this.isVisible = false;
    this.submit = true

    const record: any = {};
    record.created_at = this.Created_at;
    record.name = this.Name
    record.email = this.Email;
    record.password = this.Password;
    record.role = this.Role;
    record.status = this.Status;

    this.data.createUserData(record).subscribe(res => console.log(res));
    // .then((res: any) => {
    //   this.message = ' Employee data save done';
    // })
    //   .catch((error: any) => { console.log(error); });

    this.Name = '';
    this.Role = '';
    this.Email = ''

  }

  EditUser(record: any) {
    if (this.editVisible = true) {
      this.frmRegister.patchValue({
        name: record.name,
        email: record.email,
        role: record.role,
        id: record.id

      })
    };
    this.id = record.id
    /* this.editVisible = true;
     record.Name = record.name;
     record.email = record.email;
     record.role = record.role;
  */

  }
  Delete(deleteData: any) {
    console.log(deleteData);
    this.data.deleteUser(deleteData).subscribe((res: any) => res)

  }

  updateUser(data: any): void {

    const updateData: any = {};
    // updateData.name = data.name;
    // updateData.email = data.email;
    updateData.role = data.role;
    updateData.UpdatedAt = new Date().toISOString();
    updateData.id = this.id;
    this.data.updateUserData(updateData).subscribe((res: any) => res)
    this.editVisible = false;

  }





}
